Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    radioButtonMotionDuration: "100ms",
    radioButtonMotionFunction: "ease",
    radioButtonForegroundColorDefault: tokens.themeInkDefault,
    radioButtonForegroundColorDisabled: tokens.themeInkDisabled,
    radioButtonLabelSmallFontSize: 14,
    radioButtonLabelSmallFontWeight: 400,
    radioButtonLabelSmallLineHeight: "20px",
    radioButtonLabelMediumFontSize: 16,
    radioButtonLabelMediumFontWeight: 400,
    radioButtonLabelMediumLineHeight: "24px",
    radioButtonLabelLargeFontSize: 16,
    radioButtonLabelLargeFontWeight: 400,
    radioButtonLabelLargeLineHeight: "24px",
    radioButtonBackgroundColorSelectedDefault: tokens.themeActionPrimaryDefault,
    radioButtonBackgroundColorSelectedHover: tokens.themeActionPrimaryHover,
    radioButtonBackgroundColorSelectedPressed: tokens.themeActionPrimaryPressed,
    radioButtonBackgroundColorSelectedDisabled: tokens.themeActionPrimaryDisabledSubdued,
    radioButtonBackgroundColorUnselectedDefault: tokens.themePageDefault,
    radioButtonBackgroundColorUnselectedHover: tokens.themeActionPrimaryHover,
    radioButtonBackgroundColorUnselectedPressed: tokens.themeActionPrimaryPressed,
    radioButtonBackgroundColorUnselectedDisabled: tokens.themeActionNeutralDisabled,
    radioButtonBorderWidth: 1,
    radioButtonBorderRadius: 999,
    radioButtonBorderColorSelectedDefault: "rgba(0, 0, 0, 0)",
    radioButtonBorderColorSelectedDisabled: tokens.themeBorderDisabled,
    radioButtonBorderColorUnselectedDefault: tokens.themeBorderFormfield,
    radioButtonBorderColorUnselectedHover: "rgba(0, 0, 0, 0)",
    radioButtonBorderColorUnselectedPressed: "rgba(0, 0, 0, 0)",
    radioButtonBorderColorUnselectedDisabled: tokens.themeBorderDisabled,
    radioButtonIndicatorDiameterSmall: 8,
    radioButtonIndicatorDiameterMedium: 8,
    radioButtonIndicatorDiameterLarge: 10,
    radioButtonIndicatorColorSelectedDefault: tokens.themeInkInverse,
    radioButtonIndicatorColorSelectedDisabled: tokens.themeActionNeutralDisabled,
    radioButtonIndicatorColorUnselectedDefault: "rgba(0, 0, 0, 0)",
    radioButtonIndicatorColorUnselectedHover: tokens.themeActionPrimaryDefault,
    radioButtonIndicatorColorUnselectedPressed: tokens.themeInkInverse,
    radioButtonDiameterSmall: 20,
    radioButtonDiameterMedium: 20,
    radioButtonDiameterLarge: 24,
    radioButtonSpacingHorizontal: 12
  }
};